module.exports = __webpack_public_path__ + "img/project-type.c0318092.svg";